import page from 'page'
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Overlay from '../../components/Overlay'
import { Helmet } from 'react-helmet'
import { compose, withState, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import * as _ from 'recompose'
import { isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { fetchingState } from '../../helpers/hocs.js'
import Loader from '../../components/Loader'
import InnerHTML from 'script-inner-html'

import { pay, widgetPay } from '../../store/reducers/CP'

import { getIsLogged, getLoggedUser, getSettingsInfo } from '../../selectors/user.js'

import HelpForm from '../../components/HelpForm'

const Donate = ({ success = null, fetching, checkout, setSuccess }) => {

  return (
    <div className='Help'>
      <div>
        <div className='Container Container_no-top'>

          <div className='Container Container_light Container_white'>
            <div className='Help-top'>
              <div className='Help__header'>
                Миссия Meet For Charity - системное развитие благотворительности в России.
              </div>
              <div className='Help__text'>
                Наша команда ежедневно развивается и работает над новым проектами,
                чтобы увеличить поток средств в фонды и сделать благотворительность частью повседневной жизни каждого.
              </div>
              <div className='Help__text'>
                Вы можете поддержать проект и вместе с нами улучшать благотворительность в России.
                Мы ценим каждый вклад и в разы преумножаем его, разрабатывая новые инструменты помощи для тех,
                кому она особенно необходима.
              </div>
              <div className='Help__text'>
                Собранные средства будут направлены на развитие Meet For Charity: разработку новых
                проектов и направлений, масштабирование благотворительных программ и акций,
                технических возможностей площадки.
              </div>
              <div className="Help__text-orange">
                <a href="/aboutus" className='Link Link_orange'>Узнать о нас подробнее...</a>
              </div>
             
            </div>
          </div>

          <div className='Help-bottom'>
            <div className='Container Container_light'>
              <Helmet>
                <title>Пожертвовать MFC</title>
              </Helmet>

              <HelpForm notRequired={{}}/>
              <div className="mfc-modal__thanks">
                <b>Спасибо!</b><br />
                #КаждыйВкладИмеетЗначение
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

const mapStateToProps = state => ({
  currentLocale: state.intl.locale,
  isLogged: getIsLogged(state),
  LoggedUser: getLoggedUser(state),
  SettingsInfo: getSettingsInfo(state),
  //...state.CP

})
const mapDispatchToProps = dispatch => bindActionCreators({ pay, widgetPay }, dispatch)
const mergeProps = (state, { pay, widgetPay }, { fetchingWrap, ...props }) => ({
  ...props,
  ...state,
})

export default injectIntl(compose(
  fetchingState(),//
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  fetchingState({ multi: true }),
  withHandlers({
  }),
  lifecycle({
    async componentWillMount() {
    },
    componentDidMount() {
    }
  }),
)(Donate))


// WEBPACK FOOTER //
// ./src/containers/Donate/Help.jsx